/* Size Guide Modal JS — Pink Shop by MAF */

(function () {
  function initSizeGuide() {
    const openBtns = document.querySelectorAll('[data-size-guide-open]');
    const modal = document.getElementById('size-guide-modal');
    const closeBtns = document.querySelectorAll('[data-size-guide-close]');

    if (!modal || openBtns.length === 0) return;

    const focusableSelectors = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';

    function openModal() {
      modal.removeAttribute('hidden');
      document.body.style.overflow = 'hidden';
      const firstFocusable = modal.querySelector(focusableSelectors);
      if (firstFocusable) firstFocusable.focus();
    }

    function closeModal() {
      modal.setAttribute('hidden', '');
      document.body.style.overflow = '';
      if (openBtns[0]) openBtns[0].focus();
    }

    openBtns.forEach(btn => btn.addEventListener('click', openModal));
    closeBtns.forEach(btn => btn.addEventListener('click', closeModal));

    // Cerrar con Escape
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hasAttribute('hidden')) closeModal();
    });

    // Focus trap
    modal.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;
      const focusable = Array.from(modal.querySelectorAll(focusableSelectors));
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (e.shiftKey) {
        if (document.activeElement === first) { e.preventDefault(); last.focus(); }
      } else {
        if (document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });
  }

  // Init al cargar
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSizeGuide);
  } else {
    initSizeGuide();
  }

  // Re-init tras recarga de sección de Shopify
  document.addEventListener('shopify:section:load', initSizeGuide);
})();